export default __webpack_public_path__ + "static/Rectangle4387-d78c2d1774d77882c473ebb5228804a0.png";